import * as yup from 'yup'

export const MassPayoutConfirmationSchema = () => {
  const password = yup.string().trim().required()

  const formFields = {
    password,
  }

  return yup.object(formFields)
}
